export const brandOrange = "#E24400";
export const brandDark = "#292929";
export const white = "#FFFFFF";
export const text = "#1B1B1B";
export const link = "#004A87";
export const linkActive = "#004A8710";
export const linkHover = "#004A8714";
export const lightHover = "#CCDBE7";
export const darkHover = "#003D6F";
